<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      title="Création d'un groupe">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <spinner-round
        :is-loading="loading"
        v-if="loading"></spinner-round>
      <div
        v-else
        class="has-background-white is-border">
        <form>
          <div class="is-padding">
            <div class="field">
              <div class="control columns">
                <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                  <r-label
                    :label="'Nom du groupe'"
                    :value="group.name"></r-label>
                  <v-input
                    id="name"
                    name="name"
                    @input="val => group.name = val"
                    :model="group.name"
                    data-vv-as="Nom du groupe"
                    v-validate="'min:2'"
                    :errors-bag="errors"
                    data-vv-value-path="val">
                  </v-input>
                </div>
                <div class="column is-6 is-padding-left is-padding-right is-padding-top">
                  <r-label
                    label="Type de groupe"
                    :is-required="false"
                    :red-check="false"
                    :value="group.is_commercial"></r-label>
                  <div>
                    <input
                      type="checkbox"
                      id="is_commercial"
                      v-model="group.is_commercial"
                      class="switch is-success is-rounded is-medium">
                    <label for="is_commercial">{{ group.is_commercial ? "Utilisateur externe" : "Utilisateur interne" }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <submit-sticky-buttons
          @submit="submit"
          :loading="submitLoading"
          button-id="groupCreate"></submit-sticky-buttons>
      </div>
    </page-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GroupCreate',
  data () {
    return {
      loading: false,
      group: {
        name: null,
        is_commercial: false
      },
      submitLoading: false
    }
  },
  computed: {
    ...mapState(['currentUser'])
  },
  created () {
  },
  methods: {
    /**
      * submit group creation
      */
    async submit () {
      this.submitLoading = true
      let group = Object.assign({}, this.group)
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        try {
          await this.$api.post(this.$resources.GROUP, group)
          this.$toasted.global.success('Groupe ajouté')
          this.$router.replace({ name: 'GroupListInterne' })
          this.submitLoading = false
        } catch (e) {
          console.log(e)
          this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
          this.submitLoading = false
        }
      }
    }
  }
}
</script>
